import { render } from "./Torneo2.vue?vue&type=template&id=081756ce"
import script from "./Torneo2.vue?vue&type=script&lang=js"
export * from "./Torneo2.vue?vue&type=script&lang=js"
script.render = render

export default script